import { AnimatedPage } from '@components/AnimatedPage';
import { Spinner } from '@components/Spinner/Spinner';
import { type FC, Suspense, type ComponentType } from 'react';
import { LazyRouteErrorBoundary } from './LazyRouteErrorBoundary';

interface LazyRouteProps {
    component: ComponentType;
}

export const LazyRoute: FC<LazyRouteProps> = ({ component: Component }) => (
    <LazyRouteErrorBoundary>
        <Suspense fallback={<Spinner hideLoader={false} />}>
            <AnimatedPage>
                <Component />
            </AnimatedPage>
        </Suspense>
    </LazyRouteErrorBoundary>
);
